import mainHTTPClient from '../clients/mainHTTPClient'
import { MAIN_HTTP_API_ENDPOINTS } from '../constants/api/mainHttp'

/**
 * Search for deviceModelInputs.
 * @param listMetaData {ListMetaData}
 * @returns {Promise<AxiosResponse<object[]>>}
 * @constructor
 */
const FindMany = listMetaData => mainHTTPClient.get(
  MAIN_HTTP_API_ENDPOINTS.DEVICE_MODEL_INPUTS,
  {
    ...listMetaData.toAxiosRequestParams()
  }
)

const DeviceModelInputService = {
  FindMany
}

export default DeviceModelInputService
